import { Component, Input, OnChanges } from '@angular/core'

import { Antecipacao } from '../../../pkw-data/collect/extrato/antecipacao.model'
import { Agrupamento } from '../../../pkw-data/collect/extrato/agrupamento.model'

@Component({
    selector: 'col-detalhe-extrato-de-antecipacoes',
    templateUrl: './detalhe-extrato-de-antecipacoes.component.html',
    styleUrls: ['./detalhe-extrato-de-antecipacoes.component.scss']
})
export class DetalheExtratoDeAntecipacoesComponent implements OnChanges {
    @Input() agrupamento: Agrupamento<Antecipacao>

    maisDetalhesExpandido: boolean[]

    constructor() {}

    ngOnChanges() {
        if (this.agrupamento) {
            this.maisDetalhesExpandido = new Array(this.agrupamento.detalhes.length)
            this.maisDetalhesExpandido.fill(false)
        }
    }

    toggleCollapse(index: number, icon: HTMLSpanElement) {
        this.maisDetalhesExpandido[index] = !this.maisDetalhesExpandido[index]

        icon.classList.toggle('fa-chevron-right')
        icon.classList.toggle('fa-chevron-down')
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-antecipacoes/detalhe-extrato-de-antecipacoes/detalhe-extrato-de-antecipacoes.component.ts